export enum GoldenLayoutAdditionMode {
  DEFAULT,
  SPLIT_HORIZONTAL,
  SPLIT_VERTICAL,
  ROOT_STACK,
  NONE,
}
